module.exports = __webpack_public_path__ + "img/78.7af7074f.jpg";